module.exports = __webpack_public_path__ + "static/media/leftPos.da0be5fe.svg";